export default {
  ADDITIONS: (state) => state.additions,
};
